import { Form, Formik } from "formik";
import { Divider } from "primereact/divider";
import { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import sound from "../../assets/image/sound_sampler.svg";
import DropFileInput from "../../Components/DragAndDropFile";
import FormComponent from "../../Components/Form";
import Icon from "../../Components/Icon";
import { getDifficulte } from "../../Controller/controllerGlobal";
import { Column, Container, Padding, Row } from "../../Styles/styles";
import HomeActivitiesProvider, {
  HomeActivitiesContext,
} from "./context/context";
import {
  ButtonStart,
  HoverContainer,
  RoboIA,
  TextActivities,
  TextActivitiesCard,
  TextActivitiesParagraphCard,
} from "./styles";

import { CodeiumEditor } from "@codeium/react-code-editor";
import { ProgressBar } from "primereact/progressbar";
import * as Yup from "yup";
import robo from "../../assets/image/robozinho.svg";
import ButtonComponent from "../../Components/Button";
import FormViewComponent from "../../Components/FormView";
import Loading from "../../Components/Loading";
import color from "../../Styles/colors";
import ModalFeedback from "./modalFeedback";
import ModalRating from "./modalRating";
import { PropsCodeEditor } from "./type";

const optionSchema = Yup.object().shape({
  options_fk: Yup.number().required("Option is required"),
});

const questionSchema = Yup.object().shape({
  question_fk: Yup.number().required("Question ID is required"),
  options: Yup.array().of(optionSchema).min(1, "Marque uma opção"),
});

const createResponseSchema = Yup.object().shape({
  form_fk: Yup.number().required("Form ID is required"),
  question: Yup.array()
    .of(questionSchema)
    .required("At least one question is required"),
});

const HomeActivities = () => {
  return (
    <HomeActivitiesProvider>
      <HomeActivitiesPage />
    </HomeActivitiesProvider>
  );
};

const HomeActivitiesPage = () => {
  const propsAplication = useContext(HomeActivitiesContext);
  const [visibleRating, setVisibleRating] = useState(false);
  const [codeEditor, setCodeEditor] = useState<PropsCodeEditor[]>([]);
  const [roboModal, setRoboModal] = useState<any>();

  const dif = getDifficulte(propsAplication?.activitiesOne?.difficult);

  const { idClassroom } = useParams();

  if (!propsAplication?.activitiesOne?.user_activities)
    return <Loading />;

  const userActivity = propsAplication?.activitiesOne?.user_activities[0];
  const hasStarted = propsAplication?.activitiesOne?.user_activities.length > 0;
  const activityStatus = userActivity?.status;
  const statusLabel =
    activityStatus === "COMPLETED"
      ? "Concluída"
      : activityStatus === "AWAITING_RESPONSE"
      ? "Em processamento"
      : activityStatus === "PENDING"
      ? "Em andamento"
      : "Não iniciada";
  const statusColor =
    activityStatus === "COMPLETED"
      ? "#2F9E44"
      : activityStatus === "AWAITING_RESPONSE"
      ? "#F08C00"
      : activityStatus === "PENDING"
      ? "#2458D3"
      : "#64748B";
  const activityTypeLabel =
    propsAplication?.activitiesOne?.type_activities === "QUIZ"
      ? "Formulário"
      : propsAplication?.activitiesOne?.type_activities === "CODE"
      ? "Envio de arquivo"
      : propsAplication?.activitiesOne?.type_activities === "IA"
      ? "Correção por IA"
      : "";

  return (
    <Container
      style={{
        height: "100%",
        background: "linear-gradient(180deg, #FFFFFF 0%, #E6F0FF 100%)",
        padding: "24px clamp(16px, 4vw, 48px)",
      }}
    >
      <Row className="grid" id="space-between" style={{ width: "100%" }}>
        <div className="col-12 md:col-4 lg:col:6">
          <div className="card" style={{ borderRadius: 12 }}>
            <h3 style={{ marginTop: 0 }}>Resumo da atividade</h3>
            <Padding padding="8px" />
            <Row style={{ gap: "8px", alignItems: "center" }}>
              <TextActivitiesParagraphCard>Status:</TextActivitiesParagraphCard>
              <span
                style={{
                  padding: "4px 10px",
                  borderRadius: 999,
                  background: `${statusColor}1A`,
                  color: statusColor,
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                {statusLabel}
              </span>
            </Row>
            <Padding />
            {/* <Row style={{ gap: "4px" }}>
                                  <TextActivitiesParagraph>
                                      Pontos da Atividade:
                                  </TextActivitiesParagraph>
                                  <TextActivities>
                                      25 {`\n`}
                                  </TextActivities>
                              </Row> */}
            <Padding />
            <Row style={{ gap: "4px" }}>
              <TextActivitiesParagraphCard>
                Nível de Complexidade:
              </TextActivitiesParagraphCard>
              <TextActivitiesCard>
                {dif} {`\n`}
              </TextActivitiesCard>
            </Row>
            <Padding />

            <Row style={{ gap: "4px" }}>
              <TextActivitiesParagraphCard>
                Tempo Estimado da Atividade:
              </TextActivitiesParagraphCard>
              <TextActivitiesCard>
                {propsAplication?.activitiesOne?.time_activities} Minutos {`\n`}
              </TextActivitiesCard>
            </Row>
            <Padding />

            <Row style={{ gap: "4px" }}>
              <TextActivitiesParagraphCard>
                Tipo de atividade:
              </TextActivitiesParagraphCard>
              <TextActivitiesCard>
                {activityTypeLabel}{" "}
                {`\n`}
              </TextActivitiesCard>
            </Row>

            {propsAplication.activitiesOne?.user_activities[0]?.user_avaliation
              ?.total && (
              <>
                <Padding />
                <Row style={{ gap: "4px" }}>
                  <TextActivitiesParagraphCard>
                    Nota:
                  </TextActivitiesParagraphCard>
                  <TextActivitiesCard>
                    {propsAplication.activitiesOne?.user_activities[0]?.user_avaliation?.total?.toFixed(
                      2
                    )}{" "}
                    {`\n`}
                  </TextActivitiesCard>
                </Row>
              </>
            )}
          </div>
          {hasStarted && propsAplication?.activitiesOne?.user_activities![0] && (
            <div className="grid" style={{ marginTop: 8 }}>
              {propsAplication?.activitiesOne?.activities_group_avaliation?.map(
                (item, index) => {
                  return (
                    <Column className="col-12" key={index}>
                      <div
                        style={{
                          border: "1px solid #D9E3F0",
                          borderRadius: 12,
                          background: "#FFFFFF",
                          padding: 12,
                        }}
                      >
                      <h3 style={{ marginTop: 0, marginBottom: 4 }}>Editor: {item?.group_avaliations?.name}</h3>
                      <p style={{ margin: "0 0 8px 0", color: "#7A8798", fontSize: 13 }}>
                        Linguagem: {item?.group_avaliations?.type_group_avaliation?.value ?? "javascript"}
                      </p>
                      <Padding />
                      <CodeiumEditor
                        value={
                          propsAplication?.activitiesOne?.user_activities[0]
                            .answer_user_activities_group_avaliation
                            ? propsAplication?.activitiesOne?.user_activities[0].answer_user_activities_group_avaliation.find(
                                (props) =>
                                  props.group_avaliation_fk ===
                                  item.group_avaliation_fk
                              )?.answer
                            : codeEditor![index]?.content ?? ""
                        }
                        language={
                          item?.group_avaliations?.type_group_avaliation
                            ?.value ?? "javascript"
                        }
                        theme="light"
                        containerStyle={{
                          border: "1px solid #BAC7D5",
                          borderRadius: "8px",
                          height: "100%",
                          width: "100%",
                        }}
                        onChange={(e) => {
                          if (codeEditor.find((item) => item.id === index)) {
                            setCodeEditor((prevItems) =>
                              prevItems.map((prvent) =>
                                prvent.id === index
                                  ? { ...prvent, content: e?.toString() ?? "" }
                                  : prvent
                              )
                            );
                          } else {
                            setCodeEditor((prevt) => [
                              ...prevt,
                              {
                                content: e?.toString() ?? "",
                                id: index,
                                group: item?.group_avaliations?.name,
                                idGroup: item.group_avaliation_fk,
                              },
                            ]);
                          }
                        }}
                      />
                      </div>
                    </Column>
                  );
                }
              )}
            </div>
          )}
          <Row id="center">
            <Column style={{ width: "100%", marginTop: "16px" }}>
              <div
                style={{
                  border: "1px solid #D9E3F0",
                  borderRadius: 12,
                  background: "#FFFFFF",
                  padding: 12,
                }}
              >
              <h3 style={{ marginTop: 0 }}>Próxima ação</h3>
              <p style={{ margin: "0 0 12px 0", color: "#7A8798" }}>
                {statusLabel === "Não iniciada"
                  ? "Inicie a atividade para começar."
                  : statusLabel === "Em processamento"
                  ? "Sua resposta está sendo processada."
                  : statusLabel === "Concluída"
                  ? "Atividade já enviada."
                  : "Finalize sua resposta e envie."}
              </p>
              {propsAplication?.activitiesOne?.user_activities.length === 0 ? (
                <ButtonStart
                  style={{ marginBottom: 16 }}
                  onClick={() => {
                    propsAplication?.JoinTheActivitiesUser({
                      idActivities: propsAplication.activitiesOne?.id!,
                      idClassroom: parseInt(idClassroom!),
                    });
                  }}
                >
                  <Row id="space-around">
                    <div></div>
                    <Column id="center">Iniciar atividade</Column>{" "}
                    <img style={{ width: 48 }} src={sound} alt="" />
                  </Row>
                </ButtonStart>
              ) : propsAplication?.activitiesOne.type_activities !== "IA" &&
                userActivity?.status ===
                  "COMPLETED" ? (
                <>
                  <ButtonStart type="SUCCESS">
                    <Row id="space-around">
                      <div></div>
                      <Column id="center">Atividade enviada</Column>{" "}
                      <Icon icon="pi pi-check" size="32px" />
                    </Row>
                  </ButtonStart>
                  <Padding padding="16px" />
                </>
              ) : userActivity?.status ===
                "AWAITING_RESPONSE" ? (
                <Column>
                  <Padding padding="8px" />
                  <>Atividade em processamento</>
                  <Padding padding="8px" />
                  <ProgressBar
                    mode="indeterminate"
                    style={{ height: "6px" }}
                  ></ProgressBar>
                  <Padding padding="16px" />
                </Column>
              ) : propsAplication?.activitiesOne.type_activities === "CODE" ? (
                <>
                  <h3 style={{ marginTop: 0 }}>Anexe sua atividade para enviar</h3>
                  <Padding padding="8px" />
                  <DropFileInput onFileChange={propsAplication?.onChangeFile} />
                  <Padding padding="8px" />
                  <ButtonComponent
                    label="Enviar Atividade"
                    onClick={() =>
                      propsAplication?.FinishActivitiesUser(
                        propsAplication?.activitiesOne?.user_activities[0].id!
                      )
                    }
                  />
                  <Padding padding="16px" />
                </>
              ) : propsAplication?.activitiesOne.type_activities === "IA" &&
                propsAplication?.activitiesOne?.user_activities[0].status ===
                  "PENDING" ? (
                <>
                  <Padding padding="8px" />
                  <ButtonComponent
                    label="Enviar Atividade"
                    onClick={() => {
                      propsAplication.SendAnsweAI({
                        id_user_activities:
                          propsAplication.activitiesOne?.user_activities[0]
                            .id ?? 0,
                        tasksDescription:
                          propsAplication.activitiesOne?.description ?? "",
                        correctAnswer:
                          propsAplication.activitiesOne?.expected_return ?? "",
                        performanceMetrics:
                          propsAplication.activitiesOne?.activities_group_avaliation.map(
                            (item) => {
                              return {
                                idGroup: item.group_avaliation_fk,
                                group: item.group_avaliations.name,
                                metrics:
                                  item.group_avaliations.metric_group_avaliation.map(
                                    (metric) => {
                                      return {
                                        description: metric.description,
                                        idMetric: metric.id,
                                        metricPercentage:
                                          metric.metric_percentange,
                                        correctAnswer:
                                          metric?.metric_group_avaliation_correct_answer![0]
                                            ?.correct_answer ?? "",
                                      };
                                    }
                                  ),
                              };
                            }
                          ) ?? [],
                        student_answer: codeEditor.map((item) => {
                          return {
                            answer: item.content,
                            idGroup: item.idGroup,
                            name: item.group,
                          };
                        }),
                      });
                      // console.log({
                      //   id_user_activities:
                      //     propsAplication.activitiesOne?.user_activities[0]
                      //       .id ?? 0,
                      //   tasksDescription:
                      //     propsAplication.activitiesOne?.description ?? "",
                      //   correctAnswer:
                      //     propsAplication.activitiesOne?.expected_return ?? "",
                      //   performanceMetrics:
                      //     propsAplication.activitiesOne?.activities_group_avaliation.map(
                      //       (item) => {
                      //         return {
                      //           idGroup: item.group_avaliation_fk,
                      //           group: item.group_avaliations.name,
                      //           metrics:
                      //             item.group_avaliations.metric_group_avaliation.map(
                      //               (metric) => {
                      //                 return {
                      //                   description: metric.description,
                      //                   idMetric: metric.id,
                      //                   metricPercentage:
                      //                     metric.metric_percentange,
                      //                   correctAnswer:
                      //                     metric?.metric_group_avaliation_correct_answer![0]
                      //                       ?.correct_answer ?? "",
                      //                 };
                      //               }
                      //             ),
                      //         };
                      //       }
                      //     ) ?? [],
                      //   student_answer: codeEditor.map((item) => {
                      //     return {
                      //       answer: item.content,
                      //       idGroup: item.idGroup,
                      //       name: item.group,
                      //     };
                      //   }),
                      // });
                    }}
                  />
                  <Padding padding="16px" />
                </>
              ) : propsAplication?.activitiesOne.type_activities === "IA" &&
                propsAplication?.activitiesOne?.user_activities[0].status ===
                  "COMPLETED" ? (
                <>
                  <Padding padding="8px" />
                  <ButtonComponent
                    label="Enviar Atividade Novamente"
                    onClick={() => {
                      propsAplication.SendAnsweAI({
                        id_user_activities:
                          propsAplication.activitiesOne?.user_activities[0]
                            .id ?? 0,
                        tasksDescription:
                          propsAplication.activitiesOne?.description ?? "",
                        correctAnswer:
                          propsAplication.activitiesOne?.expected_return ?? "",
                        performanceMetrics:
                          propsAplication.activitiesOne?.activities_group_avaliation.map(
                            (item) => {
                              return {
                                idGroup: item.group_avaliation_fk,
                                group: item.group_avaliations.name,
                                metrics:
                                  item.group_avaliations.metric_group_avaliation.map(
                                    (metric) => {
                                      return {
                                        description: metric.description,
                                        idMetric: metric.id,
                                        metricPercentage:
                                          metric.metric_percentange,
                                        correctAnswer:
                                          metric?.metric_group_avaliation_correct_answer![0]
                                            ?.correct_answer ?? "",
                                      };
                                    }
                                  ),
                              };
                            }
                          ) ?? [],
                        student_answer: codeEditor.map((item) => {
                          return {
                            answer: item.content,
                            idGroup: item.idGroup,
                            name: item.group,
                          };
                        }),
                      });
                    }}
                  />
                  <Padding padding="16px" />
                </>
              ) : (
                <></>
              )}
              </div>
            </Column>
          </Row>
        </div>
        <div
          className="card col-12 md:col-7 lg:col:6"
          style={{ height: "100%", borderRadius: 12 }}
        >
          <Row>
            <Column style={{ width: "100%" }}>
              <Padding padding="24px">
                <div className="flex flex-wrap gap-2">
                  {propsAplication?.activitiesOne?.tags_activities?.map(
                    (item, index) => {
                      return (
                        <span
                          key={`${item.tag.content}-${index}`}
                          style={{
                            color: color.colorPrimary,
                            background: "#EFF4FF",
                            borderRadius: 999,
                            padding: "4px 10px",
                            fontWeight: 700,
                            fontSize: 12,
                          }}
                        >
                            #{item.tag.content}
                        </span>
                      );
                    }
                  )}
                </div>
                <Padding />
                <TextActivities>
                  {propsAplication?.activitiesOne?.name}
                </TextActivities>
                <Padding padding="16px" />
                <div style={{ fontSize: 16, lineHeight: "26px", color: "#203246" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: propsAplication?.activitiesOne?.description!,
                    }}
                  />
                </div>
                <Padding padding="16px" />
                {propsAplication?.activitiesOne?.form &&
                  userActivity && (
                    <>
                      <Divider />
                      <Padding padding="8px" />
                      <h3 style={{ margin: 0 }}>Formulário</h3>
                      <p style={{ margin: "6px 0 0 0", color: "#7A8798", fontSize: 14 }}>
                        Responda às perguntas abaixo e envie ao finalizar.
                      </p>
                      <Padding padding="16px" />
                      {propsAplication?.activitiesOne?.form.answer_form
                        ?.length! > 0 &&
                      propsAplication.activitiesOne.user_activities[0]
                        .status === "COMPLETED" ? (
                        <div
                          style={{
                            border: "1px solid #D9E3F0",
                            borderRadius: 12,
                            background: "#F8FBFF",
                            padding: 12,
                          }}
                        >
                          <Row style={{ gap: 8, alignItems: "center" }}>
                            <i className="pi pi-check-circle" style={{ color: "#2F9E44" }} />
                            <span style={{ color: "#2F9E44", fontWeight: 700, fontSize: 13 }}>
                              Formulário enviado
                            </span>
                          </Row>
                          <Padding padding="8px" />
                          <FormViewComponent
                            form={propsAplication?.activitiesOne?.form}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            border: "1px solid #D9E3F0",
                            borderRadius: 12,
                            background: "#FFFFFF",
                            padding: 12,
                          }}
                        >
                          <Formik
                            validationSchema={createResponseSchema}
                            initialValues={propsAplication.initialValueForm}
                            onSubmit={(values) => {
                              propsAplication.ResponseActivities(values);
                              setVisibleRating(true);
                            }}
                          >
                            {({ values, errors, setFieldValue }) => {
                              return (
                                <Form>
                                  <FormComponent
                                    form={propsAplication?.activitiesOne?.form!}
                                    setFieldValue={setFieldValue}
                                    values={values}
                                    errors={errors}
                                  />
                                  <Padding />
                                  {propsAplication?.activitiesOne
                                    ?.user_activities![0]?.status && (
                                    <Row id="end">
                                      <ButtonComponent
                                        type="submit"
                                        label="Enviar formulário"
                                        disabled={
                                          userActivity?.status === "COMPLETED"
                                        }
                                      />
                                    </Row>
                                  )}
                                </Form>
                              );
                            }}
                          </Formik>
                        </div>
                      )}
                    </>
                  )}
              </Padding>
            </Column>
          </Row>
        </div>
      </Row>
      <Padding padding="8px" />

      {propsAplication?.activitiesOne.type_activities === "IA" && (
        <RoboIA
          onClick={() =>
            setRoboModal(
              propsAplication.activitiesOne?.user_activities[0]
                ?.answer_user_activities_ia
            )
          }
        >
          <img alt="" src={robo} />
          <HoverContainer>
            <p>Feedback</p>
          </HoverContainer>
        </RoboIA>
      )}
      <ModalFeedback
        visible={roboModal}
        onHide={() => {
          setRoboModal(!roboModal);
        }}
      />
      <ModalRating setVisible={setVisibleRating} visible={visibleRating} />
    </Container>
  );
};

export default HomeActivities;
